import { Stack } from '@mui/material';
import { useLocalization } from '@ui-framework/index';
import { PageSection } from '@product-framework/index';
import DispatchNotifications from './DispatchNotifications';
import InsightContact from './InsightContact';

function Setup({ onChange = () => undefined }) {
  const { formatMessage } = useLocalization();

  return (
    <PageSection
      label={formatMessage({
        id: 'SERVICE_PROVIDER_NOTIFICATIONS_EDIT_HEADING',
        defaultMessage: 'Setup',
      })}>
      <Stack spacing={4} sx={{ width: '100%' }}>
        <DispatchNotifications onChange={onChange} />
        <InsightContact onChange={onChange} />
      </Stack>
    </PageSection>
  );
}

export default Setup;
